import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Row, Col, Radio } from 'antd';
import classNames from 'classnames/bind';
import styles from '../emailTemplates.less';

const cx = classNames.bind(styles);

const RadioGroup = Radio.Group;

const Radios = ({
  queryByPaging,
  setSelectedFolderData,
  selectedUser,
  setSharedByVisible,
}) => {
  const handleRadioChange = e => {
    // to empty select folder and templates
    setSelectedFolderData({});
    return e.target.value === 'name' ? setSharedByVisible(false) : setSharedByVisible(true);
  };

  return (
    <RadioGroup
      defaultValue="name"
      onChange={handleRadioChange}
    >
      <Radio className="email-theme-radio" value="name">
        {selectedUser.name}
      </Radio>
      <Radio className="email-theme-radio" value="sharedBy">
        <FormattedMessage id="page.emailTemplates.sharedBy" />
      </Radio>
    </RadioGroup>
  );
};


const TabSwitcher = ({ setPermissionSettingVisible, isPermissionSettingVisible }) => (
  <Row className="pt-lg">
    <Col className="gutter-row field-label" span={12}>
      <button
        onClick={() => setPermissionSettingVisible(false)}
        className={classNames(cx(isPermissionSettingVisible ? 'tab-button' : 'tab-button-active'), 'full-width')}
      >
        <FormattedMessage id="page.emailTemplates.templates" />
      </button>
    </Col>
    <Col className="gutter-row field-value" span={12}>
      <button
        onClick={() => setPermissionSettingVisible(true)}
        className={cx(isPermissionSettingVisible ? 'tab-button-active' : 'tab-button')}
      >
        <FormattedMessage id="page.emailTemplates.permissionSetting" />
      </button>
    </Col>
  </Row>
);

Radios.propTypes = {
  queryByPaging: PropTypes.func.isRequired,
  setSelectedFolderData: PropTypes.func.isRequired,
  selectedUser: PropTypes.object.isRequired,
  setSharedByVisible: PropTypes.func.isRequired,
};

TabSwitcher.propTypes = {
  setPermissionSettingVisible: PropTypes.func.isRequired,
  isPermissionSettingVisible: PropTypes.bool.isRequired,
};

export {
  Radios,
  TabSwitcher
};




// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/selectionController.js